export default __webpack_public_path__ + "static/media/6.04f4e29c.svg";